import { createConsts, createActions } from '../../utils/redux';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';

export const consts = createConsts('common', 'locations');
export const actions = createActions(consts);

const initialState = {
  previousLocation: null,
  currentLocation: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        previousLocation: state.currentLocation,
        currentLocation: action.payload.pathname,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/common/locations.js